module.exports = __webpack_public_path__ + "img/assets.88042d8a.svg";